import { render, staticRenderFns } from "./RenderTextArea.vue?vue&type=template&id=311c9910"
import script from "./RenderTextArea.vue?vue&type=script&lang=js"
export * from "./RenderTextArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports